export const eventsdata = [
	{ id: 1, title: 'event 1', date: '2019-12-01' },
	{
		title: 'Sesion 199',
		date: '2022-02-15',
		end: '',
		allDay: true,
	},
	{
		title: 'Sesion 200',
		start: '2022-02-16',
		end: '',
		allDay: true,
	},
	{
		title: 'Sesion 201',
		start: '2022-02-18',
		end: '',
		allDay: true,
	},
	{
		title: 'Sesion 202',
		start: '2022-02-23',
		end: '',
		allDay: true,
	},
];

export const defaultSessions = [
	{
		id: '',
		title: '',
		start: '',
		end: '',
		allDay: true,
	},
];

let eventGuid = 0;
export function createEventId() {
	return String(eventGuid++);
}
